import { getDictInfoByCode } from '@/api/dict'
export default {
  state: {
    jobList: {}
  },
  getters: {
    jobList: state => state.jobList
  },
  mutations: {
    jobList (state, data) {
      state.jobList = data
    }
  },
  actions: {
    handleJobList (jobList, data) {
      jobList.commit('jobList', data)
    }
  }
}
